import{l as t}from"./ninox-components-GQTCIGTF.js";import{f as r}from"./ninox-components-MYF6AQNE.js";import e from"styled-components";var c=e.div`
    position: relative;
    height: var(--color-swatch-size, calc(${t.m} + 2 * ${r.tiny}));
    width: var(--color-swatch-size, calc(${t.m} + 2 * ${r.tiny}));
    flex-shrink: 0;
    box-sizing: border-box;
    border-radius: var(--color-swatch-border-radius, 50%);

    isolation: isolate;
    overflow: hidden;

    transition-property: border-color, border-width, color, filter;
    transition-duration: 150ms;
    transition-timing-function: ease;

    border-style: solid;
    border-width: var(--color-swatch-border-width, ${r.tiny});
    border-color: ${({theme:o})=>o.colorSwatch.default};
    background-color: ${({theme:o})=>o.surface.primary};

    &:hover {
        border-color: ${({theme:o})=>o.colorSwatch.hover};
    }

    &:focus-within {
        border-color: ${({theme:o})=>o.colorSwatch.focus};
    }

    &:active,
    &[aria-selected='true'] {
        border-color: ${({isInvisible:o,theme:i})=>o?i.colorSwatch.default:"currentColor"};
        border-width: ${({isInvisible:o})=>!o&&`var(--color-swatch-border-selected-width, ${r.small})`};
    }

    &:focus-visible {
        outline: none;
    }

    &:not(:active)[aria-selected='true'] > input,
    &:active[aria-selected='false'] > input {
        height: calc(100% - 2 * var(--color-swatch-border-selected-offset, ${r.small}));
        width: calc(100% - 2 * var(--color-swatch-border-selected-offset, ${r.small}));
        border-radius: var(--color-swatch-selected-border-radius, inherit);
    }

    &:active > [role='presentation']:before {
        height: 90%;
        background-color: ${({theme:o})=>o.colorSwatch.default};
    }
`,l=e.input`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    height: 100%;
    width: 100%;

    padding: 0;
    margin: 0;
    border-radius: 0;

    color: currentColor;
    background-color: currentColor;
    border: none;

    appearance: none;
    cursor: pointer;

    transition-property: height, width, opacity;
    transition-duration: inherit;
    transition-timing-function: inherit;

    &:not([value]),
    &[value=''] {
        color: transparent;
        background-color: transparent;
    }

    &::-webkit-color-swatch {
        display: none;
    }
    &::-webkit-color-swatch-wrapper {
        display: none;
    }
    &::-moz-color-swatch {
        display: none;
    }

    &:focus-visible {
        outline: none;
    }
`,s=e.div`
    position: absolute;
    inset: var(--color-swatch-border-selected-width, ${r.small});
    pointer-events: none;

    transition-duration: 200ms;
    transition-timing-function: ease-in-out;

    &[aria-hidden='true'] {
        display: none;
    }

    &::before {
        content: '';
        position: absolute;

        transition-property: height, width, background-color;
        transition-duration: inherit;
        transition-timing-function: inherit;

        border-radius: inherit;
        background-color: ${({theme:o})=>o.surface.primary};

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);

        height: 100%;
        width: var(--color-swatch-border-none, ${r.smaller});
        border-radius: calc(var(--color-swatch-border-none, ${r.smaller}) / 2);

        background-color: ${({theme:o})=>o.colorSwatch.none};
    }
`;export{c as a,l as b,s as c};
//# sourceMappingURL=ninox-components-JDYDCDCP.js.map